import { render, staticRenderFns } from "./InputGroup.vue?vue&type=template&id=1d2f4509&"
import script from "./InputGroup.vue?vue&type=script&lang=js&"
export * from "./InputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2f4509')) {
      api.createRecord('1d2f4509', component.options)
    } else {
      api.reload('1d2f4509', component.options)
    }
    module.hot.accept("./InputGroup.vue?vue&type=template&id=1d2f4509&", function () {
      api.rerender('1d2f4509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Inputs/InputGroup.vue"
export default component.exports